<div class="announcement-item-title ion-text-capitalize">
  {{ announcement.title }}
</div>
<div *ngIf="showViewCount" class="announcement-item-markers">
  <app-read-eye
    label="{{ acknowledgedCount }}/{{ totalActiveRecipientsCount }}"
  />
</div>
